"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ErrorIcon = _interopRequireDefault(require("./ErrorIcon"));

var _InfoIcon = _interopRequireDefault(require("./InfoIcon"));

var _WarningIcon = _interopRequireDefault(require("./WarningIcon"));

var _SuccessIcon = _interopRequireDefault(require("./SuccessIcon"));

var _excluded = ["type"];

var getIcon = function getIcon(type) {
  if (type === 'error') {
    return _ErrorIcon.default;
  } else if (type === 'info') {
    return _InfoIcon.default;
  } else if (type === 'success') {
    return _SuccessIcon.default;
  } else if (type === 'warning') {
    return _WarningIcon.default;
  }
};

var Icon = function Icon(props) {
  var type = props.type,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var RightIcon = getIcon(type);
  return /*#__PURE__*/_react.default.createElement(RightIcon, otherProps);
};

var _default = Icon;
exports.default = _default;
//# sourceMappingURL=Icon.js.map